// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3ybX-","inner":"Footer_inner__17Igi","nextIcon":"Footer_nextIcon__6qfGM","innerLeft":"Footer_innerLeft__15DpR"};